import { AppPagePlaceholder } from "./AppPagePlaceholder";

export function LayoutsPage() {
  return <AppPagePlaceholder name="Layouts" />;
}
